import React, { Component } from "react";
import {
  Wrapper,
  Card,
  CardBody,
  Row,
  Title,
  Copy,
  Spin
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import DealFinderList from "./DealFinderList";
import InviteDealFinderCard from "./InviteDealFinderCard";
import SearchCard from "./SearchCard";
class DealFinders extends Component {
  render() {
    const { tab, team_members } = this.props;

    if (tab !== "dealfinders" || !team_members) return <Wrapper />;

    return (
      <Wrapper style={{ flex: 1 }}>
        <InviteDealFinderCard {...this.props} />
        <SearchCard {...this.props} />
        <DealFinderList {...this.props} />
      </Wrapper>
    );
  }
}

export default DealFinders;
